import { format } from 'date-fns';
import { sv } from 'date-fns/locale';
import { capitalizeFirstLetter } from './string';

function room(type, label, count) {
    return {type, label, count};
}

function singleRoom(count) {
    return room('single', 'singelrum', count);
}

function doubleRoom(count) {
    return room('double', 'dubbelrum', count);
}

function tripleRoom(count) {
    return room('triple', 'trippelrum', count);
}

function getRoomTypes(guests, useTripleRooms) {
    const remainder = guests % 2;
    const rooms = (guests - remainder) / 2;

    if (guests <= 1) {
        return [singleRoom(1)];
    }

    if (rooms - 1 === 0) {
        return useTripleRooms
            ? [tripleRoom(1)]
            : [doubleRoom(1), remainder === 1 ? singleRoom(1) : null]
                .filter(Boolean);
    }

    return useTripleRooms
        ? [doubleRoom(rooms - 1), tripleRoom(1)]
        : [doubleRoom(rooms), remainder === 1 ? singleRoom(1) : null]
            .filter(Boolean);
}

function getHotelRoomTypesList(guests, useTripleRooms) {
    return getRoomTypes(guests, useTripleRooms)
        .map((room, index) => {
            return '%count %label'
                .replace('%count', room.count)
                .replace(
                    '%label',
                    room.label,
                );
        });
}

function formatHotelDate(date) {
    return format(
        date,
        'EEEE d MMM yyyy',
        {locale: sv},
    );
}

function formatHotelRange(range) {
    return capitalizeFirstLetter(
        [
            range.from && formatHotelDate(range.from),
            range.to && formatHotelDate(range.to),
        ].filter(Boolean).join(' - '),
    );
}

export {
    getRoomTypes,
    getHotelRoomTypesList,
    formatHotelDate,
    formatHotelRange,
};
